module.exports = __webpack_public_path__ + "img/women-cooperative-border.8312c965.svg";